import { NewJobApi } from '~/common/api/zeiterfassungServerApi/NewJobApi';
import { Heading } from '~/common/components/defaultUIComponents';
import useTranslate from '~/common/utils/translate';
import { Badge, Box } from '@chakra-ui/react';
import { NewJobsList } from './NewJobsList';
import React from 'react';

export const NewJobs: React.FC = () => {
  const translate = useTranslate();
  const [{ data: recordCount }] = NewJobApi.hooks.useNewJobRecordCount({
    refetchInterval: 1000 * 60,
  });

  return (
    <Box>
      <Heading mb={5}>
        {translate('dashboard.newjobs')}
        <Badge
          marginLeft={5}
          variant="outline"
          colorScheme="green"
          fontSize={25}
        >
          {recordCount?.count ?? 0}
        </Badge>
      </Heading>
      <NewJobsList />
    </Box>
  );
};
